import axios from 'axios';
import type { TFunction } from 'i18next';
import { z } from 'zod';

const validationErrorsSchema = z.object({
  errors: z.record(z.string(), z.array(z.string())),
});
const multipleMessage =
  /^The ordered quantity must be a multiple of Qty\/Ctn (\d+) in pieces\.$/;
const productQuantityMessage =
  /^SKU (\d+): ordered quantity (-?\d+) must be a positive integer and a multiple of Qty\/Ctn (\d+) in pieces\.$/;

export function getOrderedQuantityError(error: unknown, t: TFunction) {
  if (!axios.isAxiosError<unknown>(error)) {
    return null;
  }
  const result = validationErrorsSchema.safeParse(error.response?.data);
  if (!result.success) {
    return null;
  }
  const messages: string[] = [];
  for (const message of Object.values(result.data.errors).flat()) {
    const productQuantity = message.match(productQuantityMessage);
    if (productQuantity) {
      messages.push(
        t('quantityInvalidForProduct', {
          ns: 'lotSizing',
          sku: productQuantity[1],
          quantity: productQuantity[2],
          qtyCtn: productQuantity[3],
        }),
      );
      continue;
    }
    const multiple = message.match(multipleMessage);
    if (multiple) {
      messages.push(
        t('quantityMultipleQtyCtn', { ns: 'lotSizing', qtyCtn: multiple[1] }),
      );
    }
    if (
      message === 'The ordered quantity must be a positive integer in pieces.'
    ) {
      messages.push(t('quantityPositiveInteger', { ns: 'lotSizing' }));
    }
  }
  return messages.length > 0 ? messages.join(' ') : null;
}
